import { XPDF } from '@xometry/xpdf';
import clsx from 'clsx';
import React from 'react';
import { routes } from 'routes';

interface Props {
  src: string;
  className?: string;
}

const DTI = 'PDFViewer';

const PdfViewer: React.FC<Props> = ({ src, className }) => {
  return (
    <XPDF
      title="PDF Viewer"
      className={clsx('pdf-viewer', className)}
      fileURL={src}
      packageURL={routes.oms.pdfPackagePath()}
      data-testid={DTI}
    />
  );
};

export default PdfViewer;
